import { Component, OnInit, Input,Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { config } from 'src/configs/config';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service';
import { LoginService } from 'src/app/Lazy-loaded-Modules/Account-Modules/login-new/login-new.service';
@Component({
  selector: 'app-featured-collections',
  templateUrl: './featured-collections.component.html',

})
export class FeaturedCollectionsComponent implements OnInit {
  config = config;
  @Input() collections: any;
  @Input() collections1: any;
  @Input() collections2: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localService: LocalStorageService,
    private renderer: Renderer2,
    private LoginService:LoginService
  ) { }

  ngOnInit(): void {
    const script = this.renderer.createElement('script');

    script.src = 'https://platform.twitter.com/widgets.js';

    script.async = true;

    this.renderer.appendChild(document.body, script);
  }
  getClass(index) {
    if (config.title == 'ShubhCards' || config.title == 'Deera' || config.title == 'BestGifts'|| config.title == 'Carience') {
      return ((index === 0 || index === 1)) ? 'col-md-5 ' : 'col-md-5';

    }
    else if (config.title == 'Aiema'||config.title == 'Karupattiraja' || config.title == 'Cle') {
      return ((index === 0 || index === 1)) ? 'col-md-6' : 'col-md-6';

    }
    else if (config.title == 'Beaubelle') {
      return ((index === 0 || index === 1)) ? 'col-md-4' : 'col-md-4';

    }
    else if (config.title == 'BombayHardware') {
      // return ((index === 0 || index === 1)) ? 'col-md-6' : 'col-md-6';
      // return ((index === 0 || index === 1)) ? 'col-md-5 ' : 'col-md-5';
      // return ((index === 0 || index === 1)) ? 'col-md-6 ' : 'col-lg-3 col-md-6';
      // return ((index === 0 || index === 1)) ? 'col-lg-3 col-md-6 ' : 'col-lg-3 col-md-6';
      return ((index === 0 || index === 1)) ? 'width:50%' : 'width:100%';


    }
    else if (config.title == 'BBold') {
      return ((index === 0 || index === 1)) ? 'col-md-6 ' : 'col-md-12';

    }
    else {
      return ((index === 0 || index === 1)) ? 'col-md-6 ' : 'col-lg-3 col-md-2';
    }

  }

  categoryListing(category) {
    
    if (config.title == 'ShubhCards' || config.title == 'Deera' || config.title == 'BestGifts') {
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[category],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    }
    else if (config.title === 'Carience') {
      let userId = this.localService.get('UserId');
      if(userId){
      // this.router.navigate([`/productListing`], { queryParams: { terms: [category], type: 'filter' }, relativeTo: this.route, skipLocationChange: false });
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[category],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
      }
      else{
       this.router.navigate([`/login-new`], {queryParams: { url: this.router.url }, relativeTo:this.route,  skipLocationChange: false });
      }
     }
    else
    if (config.title == 'BombayHardware' || config.title == 'Beaubelle') {

      // this.router.navigate([`/productListing`], { queryParams: { terms: [category], type: 'filter' }, relativeTo: this.route, skipLocationChange: false });
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[category],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

    } else if (config.title === "BBold")
		{
			this.router.navigate([`/product`], {queryParams: { terms:[category, 'Category'], type:'searchresults' }, relativeTo:this.route,  skipLocationChange: false });

		}
    else {
      this.router.navigate([`/productListing`], { queryParams: { terms: [[category], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
      
    } 
  }


  categoryListing1(category) {
     if (config.title == 'Aiema'){
      // this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

    //   if(category==='listing') {
    //   this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

    //  } else if (category==='category'){
    //   this.router.navigate([`/category-listing`]);

    //  }

      if(category==='listing' || category==='category') {
      this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

     }

    }
    if (config.title == 'Beaubelle'){
      // this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

    //   if(category==='listing') {
    //   this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

    //  } else if (category==='category'){
    //   this.router.navigate([`/category-listing`]);

    //  }

      if(category==='listing' || category==='category') {
      this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });

     }

    }
    if (config.title == 'BombayHardware'){
      // this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });
      // this.router.navigate([`/productListing`], {queryParams: { terms:[[],['GI'],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

    }
    if (config.title == 'Cle'){
      // this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });
      // this.router.navigate([`/productListing`], {queryParams: { terms:[[],['GI'],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

    }
  }
  productsListTazTest1(category){
    if (config.title == 'Karupattiraja') {
      let userId = this.localService.get('UserId');
      if(userId){
      // this.router.navigate([`/productListing`], { queryParams: { terms: [category], type: 'filter' }, relativeTo: this.route, skipLocationChange: false });
      const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
    }    
      else{
        this.LoginService.updateAdminFormEvent({name: "ask_login"});
       this.router.navigate([`/login-new`], {queryParams: { url: this.router.url }, relativeTo:this.route,  skipLocationChange: false });
      }
    }
    else{
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
  }
  }
  brandListing(brandName) {
    if (config.title == 'Karupattiraja') {
      let userId = this.localService.get('UserId');
      if(userId){
      // this.router.navigate([`/productListing`], { queryParams: { terms: [category], type: 'filter' }, relativeTo: this.route, skipLocationChange: false });
      this.router.navigate([`/productListing`], {queryParams: { terms:[[],[brandName],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    }    
      else{
        this.LoginService.updateAdminFormEvent({name: "ask_login"});
       this.router.navigate([`/login-new`], {queryParams: { url: this.router.url }, relativeTo:this.route,  skipLocationChange: false });
      }
    }
    else{
      this.router.navigate([`/productListing`], { queryParams: { terms: [brandName, 'Brand'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });

    }
      }
  navigateTobeaubelle() {
    this.router.navigate([`/productListing`], {queryParams: { terms:[['Beaubelle'],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    //this.router.navigate([`/productListing`], { queryParams: { terms: ['Beaubelle'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
 }
 navigateTobblabs() {
  this.router.navigate([`/productListing`], {queryParams: { terms:[['B&B Labs'],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
  //this.router.navigate([`/productListing`], { queryParams: { terms: ['B&B Labs'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
}
navigateTomccosmetics() {
  this.router.navigate([`/productListing`], {queryParams: { terms:[['MC Cosmetics'],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
  //this.router.navigate([`/productListing`], { queryParams: { terms: ['MC Cosmetics'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
}
navigateToCategory(cate) {
  if (config.title == 'Deera'){
    this.router.navigate([`/productListing`], {queryParams: { terms:[[],[cate],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

  } else {
    this.router.navigate([`/productListing`], {queryParams: { terms:[[],[cate],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
  }
  //this.router.navigate([`/productListing`], { queryParams: { terms: ['Beaubelle'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
}

   bigImg(x) {
    x.style.height = "95%";
    x.style.width = "110%";
  }
  
 normalImg(x) {
    x.style.height = "90%";
    x.style.width = "100%";
   
  }

}
